import { render, staticRenderFns } from "./TheConstructionDetails.vue?vue&type=template&id=1a5a7da2&"
import script from "./TheConstructionDetails.vue?vue&type=script&lang=js&"
export * from "./TheConstructionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports